<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.system_health_status_notifications.description' | escapeHtml"></div>
        <div [innerHTML]="'tkey;system_status.zpc.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    @if (!hasEmailSettings()) {
      <div
        class="ziro-page-alert alert border-warning w-100 mt-1"
        data-automation="system-health-settings-notifications-no-email-settings-alert"
      >
        <i class="text-warning fa-4x" [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
        <div class="ms-3" [innerHTML]="'tkey;admin.system_health_status_notifications.warning' | escapeHtml"></div>
      </div>
    }

    <div [hidden]="!hasEmailSettings()" class="list-group list-group-striped mb-3 border-rad-all-12 card-shadow">
      <div class="list-group-item position-relative">
        <ziro-general-settings-checkbox [fieldId]="'automaticDisableOfEndpoints'"></ziro-general-settings-checkbox>
      </div>
      <div class="list-group-item position-relative">
        <ziro-general-settings-text [fieldId]="'healthCheckIntervalInMinutes'"></ziro-general-settings-text>
      </div>
    </div>

    <ziro-collapsible-section-card
      [hidden]="!hasEmailSettings()"
      [isSwitchHidden]="true"
      [title]="'tkey;admin.system_health_status_notifications.title'"
      [isCollapsible]="false"
    >
      <ziro-multi-checkbox [fieldId]="'notificationsTrigger'"></ziro-multi-checkbox>
      <ziro-text [fieldId]="'failureThresholdForWarnings'"></ziro-text>
      <ziro-text [fieldId]="'repeatNotificationWarnings'"></ziro-text>
      <ziro-text [fieldId]="'failureThresholdForErrors'"></ziro-text>
      <ziro-text [fieldId]="'repeatNotificationErrors'"></ziro-text>
      <ziro-multi-text [fieldId]="'to'"></ziro-multi-text>
    </ziro-collapsible-section-card>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
